import { useEffect, useState } from 'react';

/** Seconds since `since`, ticking once a second, so a long answer visibly keeps going. */
export function ElapsedSeconds({ since }: { since: number }) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const id = window.setInterval(() => { setNow(Date.now()); }, 1000);
    return () => { window.clearInterval(id); };
  }, []);
  return <>{Math.max(0, Math.round((now - since) / 1000))}s</>;
}
